import dayjs, { Dayjs } from 'dayjs'
require('dayjs/locale/es')
var localizedFormat = require('dayjs/plugin/localizedFormat')
var customParseFormat = require('dayjs/plugin/customParseFormat')
var duration = require('dayjs/plugin/duration')
var relativeTime = require('dayjs/plugin/relativeTime')

dayjs.extend(localizedFormat)
dayjs.extend(duration)
dayjs.extend(relativeTime)
dayjs.extend(customParseFormat)

type DateType = string | number | Date | Dayjs

declare module 'dayjs' {
  interface Dayjs {
    fromNow(withoutSuffix?: boolean): string
    from(compared: DateType, withoutSuffix?: boolean): string
    toNow(withoutSuffix?: boolean): string
    to(compared: DateType, withoutSuffix?: boolean): string
  }
}

export const createDate = (date?: any) => {
    return dayjs(date);
}

export function formatDate(
  date: DateType,
  formatString: string
): string {
  return dayjs(date).format(formatString)
}
